export default {
  badge: 'Značka',
  close: 'Zatvori',
  dataIterator: {
    noResultsText: 'Nema pronađenih rezultata',
    loadingText: 'Učitavanje stavki...',
  },
  dataTable: {
    itemsPerPageText: 'Redova po stranici:',
    ariaLabel: {
      sortDescending: 'Sortirano opadajuće.',
      sortAscending: 'Sortirano rastuće.',
      sortNone: 'Nije sortirano.',
      activateNone: 'Aktiviraj da ukloniš sortiranje.',
      activateDescending: 'Aktiviraj da sortiraš opadajuće.',
      activateAscending: 'Aktiviraj da sortiraš rastuće.',
    },
    sortBy: 'Sortiraj po',
  },
  dataFooter: {
    itemsPerPageText: 'Stavki po stranici:',
    itemsPerPageAll: 'Sve',
    nextPage: 'Sljedeća stranica',
    prevPage: 'Prethodna stranica',
    firstPage: 'Prva stranica',
    lastPage: 'Posljednja stranica',
    pageText: '{0}-{1} od {2}',
  },
  datePicker: {
    itemsSelected: '{0} izabrano',
    nextMonthAriaLabel: 'Sljedeći mjesec',
    nextYearAriaLabel: 'Sljedeća godina',
    prevMonthAriaLabel: 'Prethodni mjesec',
    prevYearAriaLabel: 'Prethodna godina',
  },
  noDataText: 'Nema dostupnih podataka',
  carousel: {
    prev: 'Prethodna slika',
    next: 'Sljedeća slika',
    ariaLabel: {
      delimiter: 'Karusel slajd {0} od {1}',
    },
  },
  calendar: {
    moreEvents: 'Još {0}',
  },
  fileInput: {
    counter: '{0} datoteka',
    counterSize: '{0} datoteka ({1} ukupno)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Navigacija paginacije',
      next: 'Sljedeća stranica',
      previous: 'Prethodna stranica',
      page: 'Idi na stranicu {0}',
      currentPage: 'Trenutna stranica, Stranica {0}',
    },
  },
  rating: {
    ariaLabel: {
      icon: 'Ocjena {0} od {1}',
    },
  },
}
